import { ReactNode } from 'react';

import { Charity, DonationForm, DonationFormMailBodies, DonationFormMailSubjects, SharedProps, SubscriptionMailVariables } from '../../types';
import Container from '../../UI/Container';
import Layout from '../../UI/Layout';
import { DonationFormLayout } from './DonationFormLayout';
import EditDonationFormMailsForm from './EditDonationFormMailsForm';

export interface EditDonationFormPageProps extends SharedProps {
  donationForm: DonationForm & DonationFormMailSubjects & DonationFormMailBodies & SubscriptionMailVariables;
  charity: Charity;
}

export default function EditDonationFormPage({
  donationForm,
  charity,
  auth: {
    user,
  },
}: EditDonationFormPageProps) {
  return (
    <Container>
      <EditDonationFormMailsForm
        donationForm={donationForm}
        charity={charity}
        user={user}
      />
    </Container>
  );
}

EditDonationFormPage.layout = (page: ReactNode) => <Layout><DonationFormLayout>{page}</DonationFormLayout></Layout>;
